import LoadingOverlay from '@/components/LoadingOverlay';

type LogoutOverlayProps = {
  open: boolean;
};

const LogoutOverlay = ({ open }: LogoutOverlayProps) => (
  <LoadingOverlay open={open} title="Signing out…" subtitle="Redirecting you to sign in" />
);

export default LogoutOverlay;
